/* global location console $ */
// import 'babel-polyfill';
import events from 'events';
import App from './app';
import util from '../lib/util';
import log from '../lib/log';
import lang from './lang';
import { getScript } from './assets';
import '../lib/svgicon';
// mock
import mockConfig from './mockConfig';
import { appConfigFormat } from './model/formatappconfig';

import EventBus from './context/eventbus';

export default class Mebot extends events {
  constructor(options) {
    super(options);
    this.qs = util.queryString.parse(location.search.substring(1));
    this.options = options;

    // 接口可配置 options.model
    this.model = this.initModel(options);
    getScript('//g.alicdn.com/crm/alicare-animation/0.0.3/AlicareAni.js', () => {
    });
  }
  /**
   * 初始化APP
   * 同时加载 JSBridge & 应用配置
   */
  start() {
    const config = appConfigFormat(this.options.config);
    this.appConfig = config;
    this.initApp(config);
  }

   /**
   * 初始化APP
   */
  initApp(config) {
    util.lang.resetLang(this.options.lang || lang);
    const app = new App({
      param: this.options.param,
      log,
      model: this.model,
      appConfig: config,
      env: util.getEnvironment(),
      container: this.options.container ? this.options.container : document.body,
      essentials: this.options,
      lang: this.options.lang,
    });
    // 设置lang todo 国际化
    this.app = app;

    app.start();

    // app.on('liveAgent', (e) => {
    //   this.emit('liveAgent', { imSid: app.param.imSid || config.get('base').imsid });
    //   log.liveAgent(e);
    // });

    EventBus.emit('ready', config);

    EventBus.on('login', (e) => {
      this.emit('login', e);
      log.send({
        c: 'event',
        d: 'login',
      });
    });

    EventBus.on('liveAgent', (e) => {
      this.emit('liveAgent', { imSid: app.param.imSid || config.get('base').imsid });
      log.liveAgent(e);
    });

    EventBus.on('sessionExpired', () => {
      this.emit('sessionExpired');
      log.send({
        c: 'event',
        d: 'sessionExpired',
      });
    });

    EventBus.on('cancelResult', (e) => {
      this.emit('cancelResult', e);
      log.send({
        c: 'event',
        d: 'cancelResult',
      });
    });

    EventBus.on('bankTransfer', (e) => {
      this.emit('bankTransfer', e);
      log.send({
        c: 'event',
        d: 'bankTransfer',
      });
    });
    /**
     * 埋点通用参数设置
     */
    if (!util.isPC()) {
      this.initLog(config);
    }
  }

  /**
   * mock 配置参数
   */
  mockConfig() {
    return new Promise((resolve) => {
      resolve(appConfigFormat(mockConfig));
    });
  }

  /**
   * 实例化数据请求对象
   */
  initModel(options) {
    const qs = this.qs;
    const model = options.model;

    // 访客，设置authCode参数
    if (qs.portalType === 'guest') {
      model.authCode = qs.authCode;
    }

    return model;
  }

  feedback(e) {
    this.app.sendMsg({ q: 'test', ext: { botJson: JSON.stringify(e.action) } }, 'text', false);
  }


  robotMock(msg) {
    this.app.appendMessage({
      type: 'robot',
      body: {
        text: msg || 'What else can I help you with?',
      },
    });
  }

  scrollToBottom() {
    this.app.view.body.scrollToBottom();
  }

  initLog(config) {
    const defaultConfig = {
      from: config.get('base').from || 'lazada',
      userId: config.get('user').userId,
      memberType: config.get('user').memberType,
      imsid: config.get('base').imsid,
      type: 'dingding_channel',
      robotCode: config.get('robot').robotCode,
    };
    log.setLog(defaultConfig);
    log.send({
      c: 'mebot',
      d: 'show',
      ext: defaultConfig,
    }, true);
  }
  /**
   * pc专用
   */
  pvLog() {
    const config = this.appConfig;
    const defaultConfig = {
      from: config.get('base').from || 'lazada',
      userId: config.get('user').userId,
      memberType: config.get('user').memberType,
      imsid: config.get('base').imsid,
      type: 'dingding_channel',
      robotCode: config.get('robot').robotCode,
    };
    log.setLog(defaultConfig);
    log.send({
      c: 'mebot',
      d: 'show',
      ext: defaultConfig,
    }, true);
  }

}



// WEBPACK FOOTER //
// ./src/app/index.js